import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Table from '../../../../shared/table';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import { INVOICES_STATUS } from '../../../../utils/constants/invoices-status';

const tableColumns = ['Invoice Id', 'Customer', 'Due Date', 'Amount', 'Status', 'Actions']

interface IPayableTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onSeeDetails: (data: any) => void;
}

const PayableTable = ({
    rows,
    paginationData,
    rowsLoading,
    setPaginationState,
    onSeeDetails,
}: IPayableTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.invoiceNumber || row?.invoiceId}</td>
                                <td className='px-6 py-4'>{row?.clientInfo?.name}</td>
                                <td className='px-6 py-4'>{moment(row?.dueDate).format('DD/MM/YYYY, h:mm:ss a')}</td>
                                <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(row?.invoiceInfo?.currency || '').toLowerCase()}`]}{Number(row?.invoiceInfo?.total || 0)?.toFixed(2)}</td>
                                <td className='px-6 py-4'>{row?.status ? INVOICES_STATUS?.find((item: any)=> item?.value === row?.status)?.label || row?.status : row?.status}</td>
                                <td className='px-4 py-4'>
                                    <div className='flex flex-row justify-around'>
                                        <div data-qa={'view-details'} onClick={() => onSeeDetails(row)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-3'} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default PayableTable;